import { connect } from "react-redux";
import { withRouter } from 'react-router-dom'
import { fetchUserNotifications, fetchAllUsers } from '../../redux/actions/user_actions'
import { fetchAllFeedback } from '../../redux/actions/feedback_actions'
import WebSocketReceiver from './WebSocketReceiver'

//Redux
//mapStateToProps
// mapStateToProps
const mSTP = state => {
    // console.log('State:', state);
    // console.log('State Session:', state.session);
    return {
        users: Object.values(state.users),
        currentUser: state.session.user
    };
};

//redux actions
//mapDispatchToProps
const mDTP = dispatch => ({
    refreshFeedbacks: () => dispatch(fetchAllFeedback()), 
    fetchAllUsers: () => dispatch(fetchAllUsers()),
    refreshUserNotifications: (userId) => dispatch(fetchUserNotifications(userId))
});

export default withRouter(connect(mSTP, mDTP)(WebSocketReceiver))